// US mobile numbers, 10 digits. The phone inputs keep only these digits in
// state, so what the field shows is exactly what is sent. A leading country
// code 1 (autofill "+1 415 555 1234") is dropped; US area codes never start
// with 1, so an 11-digit value starting with 1 always carries one. Anything
// past 10 digits is dropped rather than hidden.
export const usPhoneDigits = (raw) => {
  let d = String(raw || "").replace(/\D/g, "");
  if (d.length > 10 && d[0] === "1") d = d.slice(1);
  return d.slice(0, 10);
};

export const formatPhone = (raw) => {
  const d = usPhoneDigits(raw);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
